import ListGrid from './ListGrid.vue';

export default ListGrid;



// WEBPACK FOOTER //
// ./src/pages/profile/components/listgrid/index.ts